import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AccountService, tiers } from '../../service/account.service';
import { ApiService } from '../../service/api.service';
import { PowSolution } from '../../service/pow.service';

@Component({
  selector: 'app-connect-patreon-pending',
  imports: [MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './connect-patreon-pending.component.html',
  styleUrl: './connect-patreon-pending.component.less'
})
export class ConnectPatreonPendingComponent {
  private dialogRef = inject(MatDialogRef);

  accountService = inject(AccountService);
  api = inject(ApiService);

  oauth_code: string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { oauth_code: string, pow: PowSolution }
  ) {}

  ngOnInit() {
    this.api.post("account/connect_patreon.php", {
      code: this.data.oauth_code,
      pow: this.data.pow
    }).subscribe((data: any) => {
      if (data.code == 200) {
        let newAccount = this.accountService.account.value;
        if (newAccount) {
          newAccount.connections.patreon = data.patreon_connection;
          newAccount.connections.patreon!.subscriptionTier = tiers[data.patreon_connection.subscription_tier];
          this.accountService.account.next(newAccount);
        }
        this.dialogRef.close({ success: true });
      } else {
        this.dialogRef.close({ success: false });
      }
    }, (error: any) => {
      console.error('Failed to connect Patreon:', error);
      this.dialogRef.close({ success: false });
    });
  }

  forceSuccess() {
    this.dialogRef.close({ success: true });
  }

  forceFail() {
    this.dialogRef.close({ success: false });
  }
}
